var render = function render(){var _vm=this,_c=_vm._self._c;return _c('veui-button',{class:_vm.klass,attrs:{"ui":_vm.table.uiParts.icon},on:{"click":_vm.sort}},[_c('veui-icon',{class:[_vm.$c('table-sorter-icon-sort'), _vm.$c('table-header-icon')],attrs:{"name":_vm.table.icons.sort}}),_c('veui-icon',{class:{
      [_vm.$c('table-header-icon')]: true,
      [_vm.$c('table-sorter-icon-asc')]: true,
      [_vm.$c('table-header-icon-active')]: _vm.order === 'asc'
    },attrs:{"name":_vm.table.icons.asc}}),_c('veui-icon',{class:{
      [_vm.$c('table-header-icon')]: true,
      [_vm.$c('table-sorter-icon-desc')]: true,
      [_vm.$c('table-header-icon-active')]: _vm.order === 'desc'
    },attrs:{"name":_vm.table.icons.desc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }